import React, { useContext } from "react";
// Common Components
import ServerTabBox from "src/Components/Tabbox/ServerTabBox";
import { ServerTabsContext } from "src/Layout/MasterPage";
// Local Component
import Buy from "./Buy/Buy";
import Sell from "./Sell/Sell";
import ArtificialPairPosition from "./ArtificialPairPosition/ArtificialPairPosition";
import Offset from "./Offset";
// Hooks
import { Navigate, useLocation } from "react-router-dom";

enum ActiveTab {
  Buy = "BuyTable", // جدول خرید
  Sell = "SellTable", // جدول فروش
  ArtificialPairPosition = "ArtificialPairposition", // جدول پوزیشن مصنوعی
  EntryArtificialPairposition = "EntryArtificialPairposition", // جفت پوزیشن ورود مصنوعی
  VerticalSpreads = "VerticalSpreads",
  OffsetTable = "OffsetTable", // آفست کانورژن
}

const Synthetic: React.FC = () => {
  // local state
  const location = useLocation();
  const tabs = useContext(ServerTabsContext).Synthetic;
  const visibleTabs = React.useMemo(() => tabs?.tabs?.filter(tab =>
    new URLSearchParams(tab.link.split("?")[1]).get("activeTab") !== "ConversionUser"
  ), [tabs]);
  const Tabs = React.useMemo(() => {
    const activeTab =
      new URLSearchParams(location.search).get("activeTab") || "BuyTable";
    if (activeTab === "ConversionUser") {
      return visibleTabs?.length ? <Navigate to={"/" + visibleTabs[0].link} replace /> : null;
    }
    switch (activeTab) {
      case ActiveTab.Buy:
        return <Buy />;
      case ActiveTab.Sell:
        return <Sell />;
      case ActiveTab.ArtificialPairPosition:
        return <ArtificialPairPosition key={ActiveTab.ArtificialPairPosition} />;
      case ActiveTab.EntryArtificialPairposition:
        return (
          <ArtificialPairPosition
            key={ActiveTab.EntryArtificialPairposition}
            apiTab="EntryPairPosition"
          />
        );
      case ActiveTab.VerticalSpreads:
        return (
          <ArtificialPairPosition
            key={ActiveTab.VerticalSpreads}
            apiTab="VerticalSpread"
          />
        );
      case ActiveTab.OffsetTable:
        return <Offset />;
      default:
        return <></>;
    }
  }, [location, visibleTabs]);
  return (
    <div className="flex flex-col justify-start items-start gap-2 relative min-h-screen pt-5 mx-auto p-8 w-full h-full">
      <div className="w-min">
        <ServerTabBox children={visibleTabs} />
      </div>
      {Tabs}
    </div>
  );
};

export default Synthetic;
